import { makeAutoObservable, runInAction } from "mobx";

import { IssueAjaxController, issueAjaxController } from "../Ajax/IssueAjaxController";
import { StockistIssue } from "../DTOs/StockistIssue";
import { filteringController } from "../../Pages/MainPage/Controllers/FilteringController";

type IssuePullingMode = "SEARCH" | "ALL"

// TODO: this has a bug where page number can be wrong after a couple of requests
class IssueController {
  private allIssues: StockistIssue[] = [];
  private searchIssues: StockistIssue[] = [];
  private _allIssuesPulled = false;
  private _allSearchIssuesPulled = false;
  getAllOffset = 0;
  searchPage = 1;
  // TODO: this should be in separate list controller
  private _loadingIssues = false;
  issueSearchController: IssueAjaxController;

  get pageOrOffset() {
    return this.currentMode == "ALL" ? this.getAllOffset : this.searchPage
  }

  increasePageOrOffset(mode?: IssuePullingMode) {
    const modeToUse = mode || this.currentMode
    switch (modeToUse) {
      case "ALL":
        runInAction(() => this.getAllOffset += 50)
        break
      case "SEARCH":
        runInAction(() => this.searchPage += 1)
        break
    }
  }

  private get currentMode(): IssuePullingMode {
    return filteringController.searchValue === "" ? "ALL" : "SEARCH"
  }

  getIssues(mode?: IssuePullingMode) {
    const modeToUse = mode || this.currentMode
    return modeToUse == "ALL" ? this.allIssues : this.searchIssues
  }

  setIssues(issues: StockistIssue[], mode?: IssuePullingMode) {
    const modeToUse = mode || this.currentMode
    switch (modeToUse) {
      case "ALL":
        runInAction(() => this.allIssues = issues)
        break
      case "SEARCH":
        runInAction(() => this.searchIssues = issues)
        break
    }
  }

  getAllIssuesPulled(mode?: IssuePullingMode) {
    const modeToUse = mode || this.currentMode
    return modeToUse == "ALL" ? this._allIssuesPulled : this._allSearchIssuesPulled
  }

  setAllIssuesPulled(value: boolean, mode?: IssuePullingMode) {
    const modeToUse = mode || this.currentMode
    switch (modeToUse) {
      case "ALL":
        runInAction(() => this._allIssuesPulled = value)
        break
      case "SEARCH":
        runInAction(() => this._allSearchIssuesPulled = value)
        break
    }
  }

  get loadingIssues() {
    return this._loadingIssues
  }

  set loadingIssues(value: boolean) {
    runInAction(() => this._loadingIssues = value)
  }

  async searchForIssues() {
    runInAction(() => {
      this.searchIssues = []
      this.searchPage = 1
      this._allSearchIssuesPulled = false
    })
  }

  //#region Data Fetchers
  clearIssues = () => {
    runInAction(() => {
      this.allIssues = []
      this.searchIssues = []
      this.getAllOffset = 0
      this.searchPage = 1
      this._allIssuesPulled = false
      this._allSearchIssuesPulled = false
    })
  }

  pullMoreIssues = async (mode?: IssuePullingMode) => {
    const modeToUse = mode || this.currentMode;

    if (!this.getAllIssuesPulled(modeToUse)) {
      runInAction(() => (this._loadingIssues = true));

      let result: StockistIssue[] | null

      try {
        result = await this.pullIssues(modeToUse);

        // early callback because request cancelled
        if (result === null) return;

        if (result.length === 0) {
          runInAction(() => {
            this.setAllIssuesPulled(true, modeToUse);
            this._loadingIssues = false;
          });
          return;
        }

        this.increasePageOrOffset(modeToUse);

        runInAction(() => {
          if (result === null) return;
          const existing = this.getIssues(modeToUse);
          const deduped = [
            ...existing,
            ...result.filter(r => !existing.some(e => e.id === r.id))
          ];
          this.setIssues(deduped, modeToUse);
          this._loadingIssues = false;
        });
      }
      catch (error) {
        if (error === "CANCELLED") {
          return;
        }
      }
    }
  };

  private async pullIssues(mode?: IssuePullingMode): Promise<StockistIssue[] | null> {
    const modeToUse = mode || this.currentMode
    let method;
    modeToUse == "ALL" ?
      method = this.issueSearchController.getIndieMagazinesPaged(this.pageOrOffset)
      :
      method = this.issueSearchController.search(filteringController.searchValue, this.pageOrOffset)
    try {
      return method
    } catch (error) {
      if (error === "CANCELLED") {
        return null;
      }
      return null;
    }
  }

  //#endregion

  constructor() {
    makeAutoObservable(this)
    this.issueSearchController = issueAjaxController;
  }
}

export const issueController = new IssueController()